import { render, staticRenderFns } from "./CampaignContent.vue?vue&type=template&id=22bf6e99&"
import script from "./CampaignContent.vue?vue&type=script&lang=js&"
export * from "./CampaignContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports